// extracted by mini-css-extract-plugin
module.exports = {"container":"SuccessScreen_container__1riXB","returnLink":"SuccessScreen_returnLink__2uyrw"};